import {
    GET_QUOTATION_LIST_PROGRESS, GET_QUOTATION_LIST_SUCCESS, GET_QUOTATION_LIST_FAILURE,
    ADD_QUOTATION_PROGRESS, ADD_QUOTATION_SUCCESS, ADD_QUOTATION_FAILURE,
    EDIT_DELETE_QUOTATION_PROGRESS, EDIT_DELETE_QUOTATION_SUCCESS, EDIT_DELETE_QUOTATION_FAILURE,

    RESET_MESSAGE,
    GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS,
    GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE,
    GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,

} from '../../types/actionTypes';

const initialState = {
    quotation: [],
    lastEntryNo: null,
    quotation_itemDescription_forManualEntry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const quotation_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_QUOTATION_LIST_SUCCESS:
            return { ...state, quotation: action.quotation,lastEntryNo: action.quotation[0].quotationNo, loading: false };
        case GET_QUOTATION_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_QUOTATION_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_QUOTATION_PROGRESS:
            return { ...state, loading: true };
        case ADD_QUOTATION_SUCCESS:
            return { ...state, quotation: [...state.quotation, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_QUOTATION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_QUOTATION_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_QUOTATION_SUCCESS:
            return {
                ...state,
                quotation: state.quotation.map((quotation) =>
                    quotation.id === action.payload.id ? action.payload : quotation
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_QUOTATION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS:
            return { ...state, quotation_itemDescription_forManualEntry: action.quotation_itemDescription_forManualEntry, loading: false };
        case GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default quotation_reducer;